import { useListenScrollDirection } from "@/utils/hooks/useListenScrollDirection";
import classNames from "classnames";
import { useState } from "react";
import styles from "./index.module.less";

export function ScrollHeader({ children, headerHeight, tabRef }) {
  const [visible, setVisible] = useState(false);

  useListenScrollDirection(
    () => {
      const rect = tabRef.current?.getBoundingClientRect();
      const showHeader = rect?.bottom <= headerHeight;
      setVisible(showHeader);
    },
    () => {
      const rect = tabRef.current?.getBoundingClientRect();
      const showHeader = rect?.bottom <= headerHeight;
      setVisible(showHeader);
    }
  );

  return (
    <div
      className={classNames(styles.header, {
        [styles.active]: visible,
      })}
    >
      <div className={styles.leftPlaceholder}></div>
      {children}
    </div>
  );
}
